var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideAll)?_c('div',{staticClass:"read-more-wrapper",class:_vm.cssClassContainer},[_c('div',{staticClass:"content",class:[
            _vm.contracted ? 'masked' : 'open',
            _vm.toggleDisabled ? 'no-toggle' : '',
            _vm.toggleDisabledDesktop ? 'no-toggle-desktop' : '',
            _vm.sassBackgroundColorName
        ],on:{"click":_vm.toggleExpand}},[_c('div',{class:_vm.cssClassText,domProps:{"innerHTML":_vm._s(_vm.readMoreText)}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }